<template>
  <div v-if="!showAddRoleComponent && !showEditRoleComponent">
    <!-- Show the user roles table -->
    <h1>Roles of {{ organisation.name }}</h1>
    <table class="table table-sm table-responsive-sm table-striped ">
      <thead>
      <tr>
        <th></th>
        <th>Description</th>
        <th>Multiplier</th>
        <th>Actions</th>
      </tr>
      </thead>
      <draggable v-model="roles" @end="updateRoleOrder" itemKey="id" tag="tbody" handle=".drag-handle">
        <template v-slot:item="{ element }">
          <tr :key="element.id">
            <td class="drag-handle"><i class="fas fa-grip-lines"></i></td>
            <td>{{ element.description }}</td>
            <td>{{ element.multiplier }}%</td>
            <td>
              <button class="btn btn-primary btn-sm me-2" @click="editRole(element)"><i class="fas fa-pen"/></button>
              <button class="btn btn-danger btn-sm" @click="confirmDeleteRole(element.id, element.description)"><i
                  class="fas fa-trash"/></button>
            </td>
          </tr>
        </template>
      </draggable>
    </table>
    <button class="btn btn-primary mb-3" @click="showAddRoleComponent = true">Add role</button>

  </div>
  <div v-else-if="showAddRoleComponent">
    <!-- Show the add role form -->
    <OrganisationRoleAdd :organisation=organisation @close="handleClose"/>
  </div>
  <div v-else-if="showEditRoleComponent">
    <!-- Show the edit role form -->
    <OrganisationRoleEdit :role=selectedRole @close="handleClose"/>
  </div>

</template>

<script>
import draggable from 'vuedraggable';
import {API_BASE_URL} from "@/config";
import OrganisationRoleAdd from "@/components/CreateOrganisationRole.vue";
import OrganisationRoleEdit from "@/components/EditOrganisationRole.vue";
import {getCSRFToken} from "@/store/auth";

export default {
  name: "OrganisationRolesAdmin",
  components: {OrganisationRoleAdd, OrganisationRoleEdit, draggable},
  data() {
    return {
      organisation: {},
      roles: [],
      showAddRoleComponent: false,
      showEditRoleComponent: false,
      selectedRole: {}
    }
  },
  created() {
    this.fetchRoles();
  },
  methods: {
    async fetchRoles() {
      try {
        const response = await fetch(
            `${API_BASE_URL}/organisations/${this.$route.params.slug}/roles`,
            {
              method: 'GET',
              credentials: 'include',
            }
        );
        if (response.status === 403) {
          this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
          this.$router.push({name: 'not-found'});
        } else {
          const data = await response.json();
          this.organisation = data.organisation;
          this.roles = data.roles || [];
          console.log('Fetched roles:', this.roles);
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    },
    async handleClose() {
      this.showAddRoleComponent = false;
      this.showEditRoleComponent = false;
      await this.fetchRoles();
    },
    editRole(role) {
      this.selectedRole = role;
      this.showEditRoleComponent = true;
    },
    async confirmDeleteRole(roleId, roleDescription) {
      const truncatedDescription = roleDescription.substring(0, 100);
      if (confirm(`Are you sure you want to delete the role "${truncatedDescription}"?`)) {
        await this.deleteRole(roleId);
      }
    },
    async deleteRole(roleId) {
      try {
        const response = await fetch(
            `${API_BASE_URL}/roles/${roleId}`,
            {
              method: 'DELETE',
              headers: {
                'X-CSRFToken': getCSRFToken()
              },
              credentials: 'include'
            }
        );
        if (response.ok) {
          await this.fetchRoles();
        } else {
          const errorData = await response.json();
          console.error('Error deleting role:', errorData);
        }
      } catch (error) {
        console.error('Error deleting role:', error);
      }
    },
    async updateRoleOrder() {
      try {
        const response = await fetch(
            `${API_BASE_URL}/organisations/${this.$route.params.slug}/roles/order`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken()
              },
              credentials: 'include',
              body: JSON.stringify({roles: this.roles})
            }
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error('Error updating role order:', errorData);
        }
      } catch (error) {
        console.error('Error updating role order:', error);
      }
    }
  }
}
</script>


